export default "__VITE_ASSET__e3e051ee__"